import { useQuery } from 'react-query';
import { getProfileUseCases } from '@personnel/composition';
import type { Profile } from '@personnel/domain/entities/Profile';

/**
 * React Query hook to fetch profiles.
 *
 * @returns Query result with profiles array
 *
 * @example
 * const { data: profiles } = useGetProfiles();
 */
export const useGetProfiles = () => {
  const { getProfiles } = getProfileUseCases();
  return useQuery<Profile[]>({
    queryKey: ['profiles'],
    queryFn: () => getProfiles.execute(),
  });
};
